import { SUPPORTED_LANGUAGES, type SupportedLanguages } from "@repo/shared";

export type SupportedLanguage = SupportedLanguages;

export function detectBrowserLanguage(): SupportedLanguage {
  return SUPPORTED_LANGUAGES.EN;
}

export function isSupportedLanguage(lang: string): lang is SupportedLanguage {
  return Object.values(SUPPORTED_LANGUAGES).includes(lang as SupportedLanguages);
}
